<div class="header" mat-dialog-actions>
    <div class="navigation desktop">
        <div class="left">
            <!-- <button (click)="duplicateInvoice()" mat-button>Duplicate</button> -->
            <button [disabled]="!invoice?.number" (dblclick)="deleteInvoice()" mat-button>Delete</button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-button mat-dialog-close>Close</button>
        </div>
    </div>

    <div class="navigation mobile">
        <div class="left">
            <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
        </div>
        <div class="middle">
            <button mat-button (click)="previous()">Previous</button>
            <button mat-button (click)="next()">Next</button>
        </div>
        <div class="right">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item>
                  <mat-icon>add</mat-icon>
                  <span>New Item</span>
                </button>
                <button mat-menu-item>
                  <mat-icon>content_copy</mat-icon>
                  <span>Duplicate</span>
                </button>
                <button mat-menu-item [disabled]="!invoice?.number" (click)="deleteInvoice()">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              </mat-menu>

        </div>
    </div>
</div>

<div mat-dialog-content #dialogContent>

        <div class="header-container container">
            <div class="left">
                <h2 *ngIf="mode=='edit'">Invoice #{{invoice?.number}}</h2>
                <h2 *ngIf="mode=='create'">New Invoice</h2>
            </div>
            <div class="right">
                <button color="primary" [disabled]="!hasPdf || pdfSrc == null" (click)="printPDF()" mat-raised-button>Print</button>
                <button color="primary" [disabled]="!hasPdf || pdfSrc == null" (click)="downloadPDF()" mat-raised-button>Download</button>
            </div>
        </div>
        <div class="container">
            <div class="left">
            
                <div class="actions">
                    <button [class.active]="isEditting" [disabled]="invoice == undefined" (click)="editInvoice()" mat-stroked-button>Edit Invoice</button>
                    <button [class.active]="!isEditting" [disabled]="invoice == undefined" (click)="previewInvoice()" (dblclick)="reloadPDF()" mat-stroked-button>Preview</button>
                </div>

                <mat-card *ngIf="mode=='edit'">
                    <mat-card-header>
                        <mat-card-title>Communicate</mat-card-title>
                    </mat-card-header>

                    <mat-card-content>
                        <div class="actions">
                            <button color="primary" [disabled]="invoice.customer == null || !hasPdf || invoice.amountDue == 0" (click)="openEmailInvoiceDialog()" mat-raised-button>Email Invoice</button>
                            <!-- <button [disabled]="invoice.customer == null && !hasPdf || invoice.amountDue == 0" (click)="smsInvoice()" mat-raised-button>SMS Invoice</button> -->
                            <button [disabled]="true" mat-raised-button>SMS Invoice</button>
                        </div>
           
                        <!-- <button [disabled]="invoice.customer == null || !hasPdf || invoice.amountDue == 0" (click)="addReminders()" mat-raised-button>Add Reminders</button> -->
                        <!-- <button [disabled]="true" (click)="addReminders()" mat-raised-button>Add Reminders</button> -->
            
                        <!-- <div class="reminders">
                            <div class="reminder">14 days before</div>
                            <div class="reminder">7 days before</div>
                            <div class="reminder">3 days before</div>
                            <div class="reminder">On due date</div>
                            <div class="reminder">3 days after</div>
                            <div class="reminder">7 days after</div>
                            <div class="reminder">14 days after</div>
                        </div> -->
            
                        <!-- <hr>
            
                        <div *ngFor="let communication of invoice.communicationLog">
                            <p *ngIf="communication?.state=='pending'"><strong>Pending:</strong> Email to be sent on {{communication.date.start| date:'dd MMM yy'}}</p>
                            <p *ngIf="communication?.state=='active'"><strong>Sending:</strong> Email</p>
                            <p *ngIf="communication?.state=='failed'"><strong>Failed:</strong> via Email on {{communication.ended | date:'dd MMM yy'}}</p>
                            <p *ngIf="communication?.state=='completed'"><strong>Last Sent:</strong> via Email on {{communication.ended | date:'dd MMM yy'}}</p>
                        </div> -->
                    </mat-card-content>
                </mat-card>
            
                <mat-card *ngIf="mode == 'edit'">
                    <mat-card-header>
                        <mat-card-title>Payment</mat-card-title>
                    </mat-card-header>

                    <mat-card-content>            
                        <div class="actions">
                            <button color="primary" [disabled]="invoice.amountDue == 0" (click)="openPaymentDialog(false)" mat-raised-button>Record Payment</button>
                            <button color="primary" [disabled]="invoice.amountDue != 0" (click)="openPaymentDialog(true)" mat-raised-button>Record Refund</button>
                        </div>
            
                        <hr>
            
                        <p class="payment" *ngFor="let payment of invoice.paymentsMade; index as i">
                            <ng-container *ngIf="payment.amount > 0">
                                <strong>Payment: </strong><strong>{{payment.amount | human}}</strong> on <strong>{{payment.date | date:'dd-MM-yy'}}</strong> with <strong>{{payment.method}}</strong> 
                                <button class="delete-payment" mat-button (click)="deletePayment(i)">Delete Payment</button>
                            </ng-container>
                            <ng-container *ngIf="payment.amount < 0">
                                <strong>Refund: </strong><strong>{{payment.amount | human}}</strong> on <strong>{{payment.date | date:'dd-MM-yy'}}</strong> with <strong>{{payment.method}}</strong> 
                                <button class="delete-payment" mat-button (click)="deletePayment(i)">Delete Refund</button>
                            </ng-container>
                        </p>
            
                        <div class="actions">
                            <button color="primary" [disabled]="invoice.amountDue == invoice.total" mat-button mat-raised-button (click)="openEmailReceiptDialog()">Send Receipt</button>
                            <button color="primary" [disabled]="invoice.amountDue > 0" mat-button mat-raised-button (click)="smsReview()">Send Review Link</button>
                        </div>
                    </mat-card-content>
                </mat-card>
    
            </div>

            <div class="right">

                <div *ngIf="!isEditting" class="invoice outer">
                    <div class="inner">
                        <ng-container *ngIf="pdfSrc == null">
                            <div class="generating-pdf">
                                <mat-spinner></mat-spinner>
                                Generating PDF
                            </div>
                        </ng-container>
            
                        <ng-container *ngIf="pdfSrc != null">
                            <pdf-viewer [src]="pdfSrc" [render-text]="true" [fit-to-page]="true" [original-size]="false" style="display: block;" class="pdf-viewer"></pdf-viewer>
                        </ng-container>
                    </div>
                </div>

                <div *ngIf="isEditting">
                    <app-invoice-standard *ngIf="type == 'standard'" [(invoice)]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-standard>
                    <app-invoice-ewaste *ngIf="type == 'ewaste'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-ewaste>
                    <app-invoice-msp *ngIf="type == 'msp'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-msp>
                    <app-invoice-ebay *ngIf="type == 'ebay'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-ebay>
                    <app-invoice-ebay-new-design *ngIf="type == 'ebay-new-design'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-ebay-new-design>
                    <app-invoice-repair *ngIf="type == 'repair'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-repair>
                    <app-invoice-hisense *ngIf="type == 'hisense'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-hisense>
                    <app-invoice-solvup *ngIf="type == 'solvup'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-invoice-solvup>
                    <app-rcti-invoice-ewaste *ngIf="type == 'rcti-ewaste'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-rcti-invoice-ewaste>
                    <app-rcti-invoice-repairlab *ngIf="type == 'rcti-repairlab'" [invoice]="invoice" (invoiceSaved)="invoiceSaved($event)"></app-rcti-invoice-repairlab>
                </div>

            </div>
    
        </div>
    
</div>

<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>
